import sgImgS1 from '../images/service-single/graphics/img-1.png'
import sgImgS2 from '../images/service-single/graphics/img-2.png'
import sgImgS3 from '../images/service-single/graphics/img-3.png'

import brImgS1 from '../images/service-single/brand/img-1.png'
import brImgS2 from '../images/service-single/brand/img-2.png'
import brImgS3 from '../images/service-single/brand/img-3.png'

import uxImgS1 from '../images/service-single/ux/img-1.png'
import uxImgS2 from '../images/service-single/ux/img-2.png'
import uxImgS3 from '../images/service-single/ux/img-3.png'

import dvImgS1 from '../images/service-single/development/img-1.png'
import dvImgS2 from '../images/service-single/development/img-2.png'
import dvImgS3 from '../images/service-single/development/img-3.png'

import adImgS1 from '../images/service-single/app/img-1.png'
import adImgS2 from '../images/service-single/app/img-2.png'
import adImgS3 from '../images/service-single/app/img-3.png'

import swImgS1 from '../images/service-single/softwere/img-1.png'
import swImgS2 from '../images/service-single/softwere/img-2.png'
import swImgS3 from '../images/service-single/softwere/img-3.png'

export const serviceImages = {
  '1': { sImgS: sgImgS1, ssImg1: sgImgS2, ssImg2: sgImgS3, icon: 'flaticon-vector' },
  '2': { sImgS: brImgS1, ssImg1: brImgS2, ssImg2: brImgS3, icon: 'flaticon-palette' },
  '3': { sImgS: uxImgS1, ssImg1: uxImgS2, ssImg2: uxImgS3, icon: 'flaticon-add' },
  '4': { sImgS: dvImgS1, ssImg1: dvImgS2, ssImg2: dvImgS3, icon: 'flaticon-coding' },
  '5': { sImgS: adImgS1, ssImg1: adImgS2, ssImg2: adImgS3, icon: 'flaticon-app-development' },
  '6': { sImgS: swImgS1, ssImg1: swImgS2, ssImg2: swImgS3, icon: 'flaticon-smartphone' },
};
